export default __webpack_public_path__ + "static/media/ISEO CLASS-10 EXAM PATTERN 2025.8bf4783e.pdf";